import React from 'react';
import { PageContainer, ContentWrapper, Title, Subtitle } from '../styles/SharedComponents';

const TestResults: React.FC = () => {
  return (
    <PageContainer>
      <ContentWrapper>
        <Title>Página de Teste</Title>
        <Subtitle>
          Esta é uma página de teste para verificar se o problema está no arquivo Results.tsx ou em outro lugar.
        </Subtitle>
      </ContentWrapper>
    </PageContainer>
  );
};

export default TestResults; 